export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return Number.isNaN(date.getTime())
    ? dateStr
    : date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};
